import Swiper from 'swiper/bundle';

export default class CoverSliders {

    ready() {

        const WRAPPERS = document.querySelectorAll('.mtt-cover-widget--slider');
        if (WRAPPERS.length > 0) {
            for (let i = 0; i < WRAPPERS.length; i++) {
                new CoverSlider(WRAPPERS[i]);
            }
        }
    }
}

class CoverSlider {

    constructor(WRAPPER) {
        this.WRAPPER = WRAPPER;
        this.SLIDES = this.WRAPPER.querySelectorAll('.swiper-slide');
        this.TOGGLES = this.WRAPPER.querySelectorAll('.mtt-cover-widget__top-bar-toggle');
        this.hidden = false;
        
        // create swiper on init
        this.SWIPER = this.createSwiper();
    }

    createSwiper() {

        const PAGINATION = this.WRAPPER.querySelector('.swiper-pagination');
        const TEXTS = PAGINATION.getAttribute('data-toggles').split(', ');

        return new Swiper(this.WRAPPER.querySelector('.swiper-container'), {
            containerModifierClass: 'swiper-container-',
            slidesPerView: 1,
            speed: 800,
            spaceBetween: 24,
            freeMode: false,
            watchOverflow: true,
            preloadImages: false,
            lazyPreloadPrevNext: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: PAGINATION,
                type: 'bullets',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<div class="${className} mtt-cover-widget__top-bar-toggle">${TEXTS[index]}</div>`;
                }
            },
        });
    }
}
